// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfMonth as fn } from "../startOfMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfMonth = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfMonth;
